import styled from '@emotion/styled';

import DangerTriangle from '../../../images/DangerTriangle.svg';

const Container = styled.div<{ hidden?: boolean }>`
    background: rgba(242, 201, 76, 0.4);
    align-items: center;
    width: 100%;
    height: 45px;
    border-radius: 8px;
    font-size: 12px;
    display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
    margin-bottom: 14px;
`;

const Text = styled.div`
    margin-left: 10px;
`;

const Icon = styled.img`
    width: 20px;
    height: 20px;
    margin-left: 5px;
`;

export default function WarningMessage({ children, hidden }: { children: string; hidden?: boolean }) {
    return (
        <Container hidden={hidden}>
            <Icon src={DangerTriangle} alt="plus" />
            <Text>{children}</Text>
        </Container>
    );
}
